interface DirectusTranslationStructure {
  languages_code?: string
  languagesCode?: string
  [key: string]: any
}

export function useDirectusTranslation() {
  /**
   * Returns the directus translation object for the current locale.
   * @param translations A collection of directus translations, as they're returned by the directus SDK.
   */
  function dt<T extends DirectusTranslationStructure>(translations: T[] | null | undefined): T | null {
    const { $i18n } = useNuxtApp()

    if (!translations || translations.length === 0)
      return null

    const currentLocale = $i18n.locale.value

    return translations.find((translation) => {
      return (
        translation.languages_code === currentLocale
        || translation.languagesCode === currentLocale
      )
    }) || null
  }

  return {
    dt,
  }
}
